 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"pc": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"pc": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~experimentPage~teaCourseFile~virtualGrade":"about~experimentPage~teaCourseFile~virtualGrade","about~signature~virtualGrade":"about~signature~virtualGrade","about~scanSignature":"about~scanSignature","about":"about","experimentPage~virtualGrade":"experimentPage~virtualGrade","virtualGrade":"virtualGrade","experimentPage":"experimentPage","teaCourseFile":"teaCourseFile","courseDeclaration":"courseDeclaration","courseFile":"courseFile","coursePage":"coursePage","lang-element-af-ZA":"lang-element-af-ZA","lang-element-ar":"lang-element-ar","lang-element-bg":"lang-element-bg","lang-element-ca":"lang-element-ca","lang-element-cs-CZ":"lang-element-cs-CZ","lang-element-da":"lang-element-da","lang-element-de":"lang-element-de","lang-element-ee":"lang-element-ee","lang-element-el":"lang-element-el","lang-element-en":"lang-element-en","lang-element-es":"lang-element-es","lang-element-eu":"lang-element-eu","lang-element-fa":"lang-element-fa","lang-element-fi":"lang-element-fi","lang-element-fr":"lang-element-fr","lang-element-he":"lang-element-he","lang-element-hr":"lang-element-hr","lang-element-hu":"lang-element-hu","lang-element-hy-AM":"lang-element-hy-AM","lang-element-id":"lang-element-id","lang-element-it":"lang-element-it","lang-element-ja":"lang-element-ja","lang-element-kg":"lang-element-kg","lang-element-km":"lang-element-km","lang-element-ko":"lang-element-ko","lang-element-ku":"lang-element-ku","lang-element-kz":"lang-element-kz","lang-element-lt":"lang-element-lt","lang-element-lv":"lang-element-lv","lang-element-mn":"lang-element-mn","lang-element-nb-NO":"lang-element-nb-NO","lang-element-nl":"lang-element-nl","lang-element-pl":"lang-element-pl","lang-element-pt":"lang-element-pt","lang-element-pt-br":"lang-element-pt-br","lang-element-ro":"lang-element-ro","lang-element-ru-RU":"lang-element-ru-RU","lang-element-sk":"lang-element-sk","lang-element-sl":"lang-element-sl","lang-element-sr":"lang-element-sr","lang-element-sv-SE":"lang-element-sv-SE","lang-element-ta":"lang-element-ta","lang-element-th":"lang-element-th","lang-element-tk":"lang-element-tk","lang-element-tr-TR":"lang-element-tr-TR","lang-element-ua":"lang-element-ua","lang-element-ug-CN":"lang-element-ug-CN","lang-element-vi":"lang-element-vi","lang-element-zh-TW":"lang-element-zh-TW","lang-vant-de-DE":"lang-vant-de-DE","lang-vant-de-DE-formal":"lang-vant-de-DE-formal","lang-vant-en-US":"lang-vant-en-US","lang-vant-es-ES":"lang-vant-es-ES","lang-vant-fr-FR":"lang-vant-fr-FR","lang-vant-ja-JP":"lang-vant-ja-JP","lang-vant-nb-NO":"lang-vant-nb-NO","lang-vant-ro-RO":"lang-vant-ro-RO","lang-vant-th-TH":"lang-vant-th-TH","lang-vant-tr-TR":"lang-vant-tr-TR","lang-vant-zh-CN":"lang-vant-zh-CN","lang-vant-zh-HK":"lang-vant-zh-HK","lang-vant-zh-TW":"lang-vant-zh-TW","scanSignature~signature":"scanSignature~signature","scanSignature":"scanSignature","termManager":"termManager","virtualCourseList":"virtualCourseList","virtualHomePage":"virtualHomePage","welinkBind":"welinkBind","welinkCode":"welinkCode"}[chunkId]||chunkId) + "." + {"about~experimentPage~teaCourseFile~virtualGrade":"bf2827e7","about~signature~virtualGrade":"fc995e75","about~scanSignature":"2166768b","about":"8a3ae145","experimentPage~virtualGrade":"dabddb85","virtualGrade":"82d746f5","experimentPage":"0a44ce93","teaCourseFile":"f035d82e","courseDeclaration":"24193ff8","courseFile":"9e560de3","coursePage":"48fdf8bd","lang-element-af-ZA":"88f90c18","lang-element-ar":"4fa615a4","lang-element-bg":"2be81076","lang-element-ca":"96eb297b","lang-element-cs-CZ":"a155b6fb","lang-element-da":"0e5d7a47","lang-element-de":"e4cf8804","lang-element-ee":"1c250eba","lang-element-el":"f4a8a3e8","lang-element-en":"05c027c1","lang-element-es":"03092167","lang-element-eu":"b366ffca","lang-element-fa":"3ca9c76a","lang-element-fi":"053e7e58","lang-element-fr":"288fef73","lang-element-he":"7c08e5b5","lang-element-hr":"a76fe6a2","lang-element-hu":"8730cc86","lang-element-hy-AM":"cfceaf04","lang-element-id":"d8fa40cf","lang-element-it":"b43e11da","lang-element-ja":"76bcfbb1","lang-element-kg":"a2a5decf","lang-element-km":"c19f5f41","lang-element-ko":"7359e54e","lang-element-ku":"29a7fd07","lang-element-kz":"c07082ba","lang-element-lt":"0504647d","lang-element-lv":"a742dba1","lang-element-mn":"9989612e","lang-element-nb-NO":"5abeade9","lang-element-nl":"2f47c642","lang-element-pl":"d42bc322","lang-element-pt":"cfbd0167","lang-element-pt-br":"53176b58","lang-element-ro":"8d1e2749","lang-element-ru-RU":"3825364a","lang-element-sk":"c97a1bd2","lang-element-sl":"bc7114e3","lang-element-sr":"72f58d23","lang-element-sv-SE":"b73c3e3e","lang-element-ta":"936a4320","lang-element-th":"b3605e68","lang-element-tk":"fff10d78","lang-element-tr-TR":"18277a85","lang-element-ua":"d7fb6322","lang-element-ug-CN":"ae5fc648","lang-element-vi":"737a35ec","lang-element-zh-TW":"72dafec6","lang-vant-de-DE":"31542c26","lang-vant-de-DE-formal":"0405fd6a","lang-vant-en-US":"219fcba3","lang-vant-es-ES":"55e4dd2c","lang-vant-fr-FR":"b71de517","lang-vant-ja-JP":"1351a653","lang-vant-nb-NO":"4dbfa4eb","lang-vant-ro-RO":"5962eb2d","lang-vant-th-TH":"9e62aa6f","lang-vant-tr-TR":"678690e2","lang-vant-zh-CN":"9fc62d83","lang-vant-zh-HK":"d0cab436","lang-vant-zh-TW":"5d7d1373","scanSignature~signature":"ac8a6c0a","scanSignature":"af37b8e6","termManager":"0d93bd3d","virtualCourseList":"1b6de36c","virtualHomePage":"7b2e9029","welinkBind":"0a5c25c6","welinkCode":"8cf93fd4","chunk-2d216214":"dda534f6","chunk-8e637a8a":"bcbed3bf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~experimentPage~teaCourseFile~virtualGrade":1,"about":1,"experimentPage~virtualGrade":1,"virtualGrade":1,"experimentPage":1,"teaCourseFile":1,"courseDeclaration":1,"courseFile":1,"coursePage":1,"scanSignature":1,"termManager":1,"virtualCourseList":1,"virtualHomePage":1,"welinkBind":1,"welinkCode":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~experimentPage~teaCourseFile~virtualGrade":"about~experimentPage~teaCourseFile~virtualGrade","about~signature~virtualGrade":"about~signature~virtualGrade","about~scanSignature":"about~scanSignature","about":"about","experimentPage~virtualGrade":"experimentPage~virtualGrade","virtualGrade":"virtualGrade","experimentPage":"experimentPage","teaCourseFile":"teaCourseFile","courseDeclaration":"courseDeclaration","courseFile":"courseFile","coursePage":"coursePage","lang-element-af-ZA":"lang-element-af-ZA","lang-element-ar":"lang-element-ar","lang-element-bg":"lang-element-bg","lang-element-ca":"lang-element-ca","lang-element-cs-CZ":"lang-element-cs-CZ","lang-element-da":"lang-element-da","lang-element-de":"lang-element-de","lang-element-ee":"lang-element-ee","lang-element-el":"lang-element-el","lang-element-en":"lang-element-en","lang-element-es":"lang-element-es","lang-element-eu":"lang-element-eu","lang-element-fa":"lang-element-fa","lang-element-fi":"lang-element-fi","lang-element-fr":"lang-element-fr","lang-element-he":"lang-element-he","lang-element-hr":"lang-element-hr","lang-element-hu":"lang-element-hu","lang-element-hy-AM":"lang-element-hy-AM","lang-element-id":"lang-element-id","lang-element-it":"lang-element-it","lang-element-ja":"lang-element-ja","lang-element-kg":"lang-element-kg","lang-element-km":"lang-element-km","lang-element-ko":"lang-element-ko","lang-element-ku":"lang-element-ku","lang-element-kz":"lang-element-kz","lang-element-lt":"lang-element-lt","lang-element-lv":"lang-element-lv","lang-element-mn":"lang-element-mn","lang-element-nb-NO":"lang-element-nb-NO","lang-element-nl":"lang-element-nl","lang-element-pl":"lang-element-pl","lang-element-pt":"lang-element-pt","lang-element-pt-br":"lang-element-pt-br","lang-element-ro":"lang-element-ro","lang-element-ru-RU":"lang-element-ru-RU","lang-element-sk":"lang-element-sk","lang-element-sl":"lang-element-sl","lang-element-sr":"lang-element-sr","lang-element-sv-SE":"lang-element-sv-SE","lang-element-ta":"lang-element-ta","lang-element-th":"lang-element-th","lang-element-tk":"lang-element-tk","lang-element-tr-TR":"lang-element-tr-TR","lang-element-ua":"lang-element-ua","lang-element-ug-CN":"lang-element-ug-CN","lang-element-vi":"lang-element-vi","lang-element-zh-TW":"lang-element-zh-TW","lang-vant-de-DE":"lang-vant-de-DE","lang-vant-de-DE-formal":"lang-vant-de-DE-formal","lang-vant-en-US":"lang-vant-en-US","lang-vant-es-ES":"lang-vant-es-ES","lang-vant-fr-FR":"lang-vant-fr-FR","lang-vant-ja-JP":"lang-vant-ja-JP","lang-vant-nb-NO":"lang-vant-nb-NO","lang-vant-ro-RO":"lang-vant-ro-RO","lang-vant-th-TH":"lang-vant-th-TH","lang-vant-tr-TR":"lang-vant-tr-TR","lang-vant-zh-CN":"lang-vant-zh-CN","lang-vant-zh-HK":"lang-vant-zh-HK","lang-vant-zh-TW":"lang-vant-zh-TW","scanSignature~signature":"scanSignature~signature","scanSignature":"scanSignature","termManager":"termManager","virtualCourseList":"virtualCourseList","virtualHomePage":"virtualHomePage","welinkBind":"welinkBind","welinkCode":"welinkCode"}[chunkId]||chunkId) + "." + {"about~experimentPage~teaCourseFile~virtualGrade":"3f0559ad","about~signature~virtualGrade":"31d6cfe0","about~scanSignature":"31d6cfe0","about":"63e3e033","experimentPage~virtualGrade":"e366322f","virtualGrade":"f5a1c28e","experimentPage":"5f782912","teaCourseFile":"2e81fcb5","courseDeclaration":"447a8735","courseFile":"8cc1f456","coursePage":"ef417a14","lang-element-af-ZA":"31d6cfe0","lang-element-ar":"31d6cfe0","lang-element-bg":"31d6cfe0","lang-element-ca":"31d6cfe0","lang-element-cs-CZ":"31d6cfe0","lang-element-da":"31d6cfe0","lang-element-de":"31d6cfe0","lang-element-ee":"31d6cfe0","lang-element-el":"31d6cfe0","lang-element-en":"31d6cfe0","lang-element-es":"31d6cfe0","lang-element-eu":"31d6cfe0","lang-element-fa":"31d6cfe0","lang-element-fi":"31d6cfe0","lang-element-fr":"31d6cfe0","lang-element-he":"31d6cfe0","lang-element-hr":"31d6cfe0","lang-element-hu":"31d6cfe0","lang-element-hy-AM":"31d6cfe0","lang-element-id":"31d6cfe0","lang-element-it":"31d6cfe0","lang-element-ja":"31d6cfe0","lang-element-kg":"31d6cfe0","lang-element-km":"31d6cfe0","lang-element-ko":"31d6cfe0","lang-element-ku":"31d6cfe0","lang-element-kz":"31d6cfe0","lang-element-lt":"31d6cfe0","lang-element-lv":"31d6cfe0","lang-element-mn":"31d6cfe0","lang-element-nb-NO":"31d6cfe0","lang-element-nl":"31d6cfe0","lang-element-pl":"31d6cfe0","lang-element-pt":"31d6cfe0","lang-element-pt-br":"31d6cfe0","lang-element-ro":"31d6cfe0","lang-element-ru-RU":"31d6cfe0","lang-element-sk":"31d6cfe0","lang-element-sl":"31d6cfe0","lang-element-sr":"31d6cfe0","lang-element-sv-SE":"31d6cfe0","lang-element-ta":"31d6cfe0","lang-element-th":"31d6cfe0","lang-element-tk":"31d6cfe0","lang-element-tr-TR":"31d6cfe0","lang-element-ua":"31d6cfe0","lang-element-ug-CN":"31d6cfe0","lang-element-vi":"31d6cfe0","lang-element-zh-TW":"31d6cfe0","lang-vant-de-DE":"31d6cfe0","lang-vant-de-DE-formal":"31d6cfe0","lang-vant-en-US":"31d6cfe0","lang-vant-es-ES":"31d6cfe0","lang-vant-fr-FR":"31d6cfe0","lang-vant-ja-JP":"31d6cfe0","lang-vant-nb-NO":"31d6cfe0","lang-vant-ro-RO":"31d6cfe0","lang-vant-th-TH":"31d6cfe0","lang-vant-tr-TR":"31d6cfe0","lang-vant-zh-CN":"31d6cfe0","lang-vant-zh-HK":"31d6cfe0","lang-vant-zh-TW":"31d6cfe0","scanSignature~signature":"31d6cfe0","scanSignature":"ff54a3ae","termManager":"4e19e072","virtualCourseList":"a2097ca8","virtualHomePage":"471c1f40","welinkBind":"f4eb2f1b","welinkCode":"7322acb2","chunk-2d216214":"31d6cfe0","chunk-8e637a8a":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors","chunk-common"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
